import { useMutation, UseMutationResult } from 'react-query';
import { ApiError } from '../services/api-error.model';
import { submit, SubmitResponse } from '../services/submit.service';

export default (): UseMutationResult<SubmitResponse, ApiError, FormData> => useMutation(submit);
